import { authFetch } from "~/services/fetch";

// ! GRÁFICO DE PIZZA
export async function getOccurrencesAssossiatedVehicleBytype({
  startDate,
  finishDate,
  involvementTypeId,
  vehicleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-vehicle-by-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        vehicle_type_id: involvementTypeId,
        destination_id: destinationId,
        circunstance_id: vehicleCircunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssossiatedVehicleByBrand({
  startDate,
  finishDate,
  involvementTypeId,
  vehicleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-vehicle-by-brand',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        vehicle_type_id: involvementTypeId,
        destination_id: destinationId,
        circunstance_id: vehicleCircunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssossiatedVehicleByModel({
  startDate,
  finishDate,
  involvementTypeId,
  vehicleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-vehicle-by-model',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        vehicle_type_id: involvementTypeId,
        destination_id: destinationId,
        circunstance_id: vehicleCircunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssossiatedVehicleByState({
  startDate,
  finishDate,
  involvementTypeId,
  vehicleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-vehicle-by-state',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        vehicle_type_id: involvementTypeId,
        destination_id: destinationId,
        circunstance_id: vehicleCircunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssossiatedVehicleByDestination({
  startDate,
  finishDate,
  involvementTypeId,
  vehicleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-vehicle-by-destination',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        vehicle_type_id: involvementTypeId,
        destination_id: destinationId,
        circunstance_id: vehicleCircunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssossiatedVehicleByCircunstance({
  startDate,
  finishDate,
  involvementTypeId,
  vehicleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-vehicle-by-circunstance',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        vehicle_type_id: involvementTypeId,
        destination_id: destinationId,
        circunstance_id: vehicleCircunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedVehicleByOccurrenceType({
  startDate,
  finishDate,
  involvementTypeId,
  vehicleCircunstanceId,
  destinationId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-vehicle-by-occurrence-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        vehicle_type_id: involvementTypeId,
        destination_id: destinationId,
        circunstance_id: vehicleCircunstanceId,
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}